import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="bg-white py-10 px-6 md:py-16" data-id="element-228">
      <div className="max-w-3xl mx-auto" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4 text-lg leading-relaxed" data-id="element-230">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal mb-5" data-id="element-231">
            Et si je te disais quelque chose que personne ne t'a encore dit ?
          </h2>

          <p className="text-xl" data-id="element-232">
            Ce vide que tu ressens... ce n'est pas un problème.
          </p>

          <p className="text-2xl font-semibold text-burgundy" data-id="element-233">
            C'est un signal.
          </p>

          <p data-id="element-234">
            Le signal que quelque chose de plus grand est en train de naître en
            toi.
          </p>

          <p className="pt-4" data-id="element-235">
            Autour de toi, tout le monde a eu deux conseils brillants :
          </p>

          <div className="space-y-4 py-6" data-id="element-236">
            <div className="flex items-start gap-3" data-id="element-237">
              <XIcon className="text-red-600 flex-shrink-0 mt-1" size={24} data-id="element-238" />
              <p className="line-through text-gray-600" data-id="element-239">
                "Tourne la page." (Comme si c'était aussi simple que fermer un
                livre.)
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-240">
              <XIcon className="text-red-600 flex-shrink-0 mt-1" size={24} data-id="element-241" />
              <p className="line-through text-gray-600" data-id="element-242">
                "Trouve quelqu'un d'autre." (Comme si un homme pouvait
                reconstruire ce que seule TOI peux reconstruire.)
              </p>
            </div>
          </div>

          <p className="text-xl font-semibold" data-id="element-243">Ils ont tous tort.</p>

          <p data-id="element-244">
            Ta reconstruction n'a pas besoin d'un avocat. Elle n'a pas besoin
            d'un thérapeute à 200$/heure. Elle n'a certainement pas besoin d'une
            application de rencontres.
          </p>

          <p className="text-xl" data-id="element-245">Elle a besoin d'une seule chose.</p>

          <p data-id="element-246">
            La décision de ne plus être "l'ex de..." Ou seulement "la maman
            de..." Mais de redevenir, enfin...{' '}
            <span className="font-semibold text-burgundy" data-id="element-247">TOI.</span>
          </p>

          <div className="py-4 space-y-2 text-center" data-id="element-248">
            <p className="text-2xl font-playfair text-gold" data-id="element-249">
              Une femme souveraine.
            </p>
            <p className="text-2xl font-playfair text-gold" data-id="element-250">
              Une femme rayonnante.
            </p>
            <p className="text-2xl font-playfair text-gold" data-id="element-251">
              Une femme complète par elle-même.
            </p>
          </div>

          <p className="text-xl font-semibold text-burgundy pt-3" data-id="element-252">
            C'est exactement ce que fait la Méthode RE-NAISSANCE.
          </p>
        </motion.div>
      </div>
    </section>;
}